import { ButtonGroup } from "./ButtonGroup";
import { Lang, getTranslation } from "@/data/translation";
import { TimeFrame } from "charts/src/types/chart";

type TimeFrameButtonGroupParams = {
  lang: Lang;
  timeFrame: TimeFrame;
  setTimeFrame: (timeFrame: TimeFrame) => void;
  timeFrameOptions: TimeFrame[];
};

export const TimeFrameButtonGroup = ({
  lang,
  timeFrame,
  setTimeFrame,
  timeFrameOptions,
}: TimeFrameButtonGroupParams) => {
  const options = getTimeFrameOptions({ lang, timeFrameOptions });

  const onClick = (value: string) => {
    setTimeFrame(value as TimeFrame);
  };

  return (
    <ButtonGroup
      options={options}
      activeId={timeFrame}
      onButtonClick={onClick}
    />
  );
};

const getTimeFrameOptions = ({
  lang,
  timeFrameOptions,
}: {
  lang: Lang;
  timeFrameOptions?: TimeFrame[];
}) => {
  const { t } = getTranslation({ lang });
  const OptionMap = {
    Y: { id: "Y", name: t.date.timeFrame.year },
    M: { id: "M", name: t.date.timeFrame.month },
    Q: { id: "Q", name: t.date.timeFrame.quarter },
    "4Q": { id: "4Q", name: t.date.timeFrame.fourQuarter },
  };

  if (!timeFrameOptions) {
    return Object.values(OptionMap);
  }

  return timeFrameOptions.map((option) => OptionMap[option]);
};
